<template>
  <div class="">
    <b-container>
      <b-row class="py-3">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" :createline="false" eheader="PI Item" econtent="PI Item"
                eimg="/src/assets/Img/icons/Item.svg" @createNew="" />
              <!-- {{ List  }} -->
              <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                :rows="10" :totalRecords="rowsCount" :rowHover="true" filterDisplay="menu" :loading="loading1"
                responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                :serialNumber="true" selectionMode="single" @row-click="RowClick">

                <template v-slot:StockInHand="{ data }">
                  {{
                    (data.StockInHand - (data.PickedQty + data.InTransist)).toFixed(2)
                  }}
                </template>

                <template v-slot:Brandmodelsize="{ data }">
                  <span>
                    <template v-if="data.BrandName">{{ data.BrandName }}</template>
                    <template v-if="data.BrandName && data.ModelNumberName">/</template>
                    <template v-if="data.ModelNumberName">{{ data.ModelNumberName }}</template>
                    <template v-if="(data.BrandName || data.ModelNumberName) && data.SizeName">/</template>
                    <template v-if="data.SizeName">{{ data.SizeName }}</template>
                  </span>
                </template>
                <template v-slot:action="{ data }">
                  <span>

                    <EditIcon @click="IsConfirmEdit(data)" class="me-3" />
                    <DeleteIcon @click="IsConfirmDel(data)" />
                  </span>
                </template>
              </Tableview>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" :createline="false" eheader="PI Item" econtent="PI Item"
                eimg="/src/assets/Img/icons/Item.svg" @createNew="" />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div class="d-flex align-items-center gap-1">
                      <p class="light-name">{{ item['ItemCode'] }} /</p>
                      <p class="light-name1">{{ item['HSNCode'] }}</p>
                    </div>
                    <p class="name">{{ item['Itemname1'] }}</p>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Requested Quantity :</p>
                      <p class="small-name">{{ item['ItemQuantity'] }}</p>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Stock in Hand :</p>
                      <p class="small-name">{{ item['StockInHand'] }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
      :content="$t('confirmation.editcontent')" />
    <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(dataEdit)" @no="Deletemodel = false" />
    <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  </div>
  <ItemsRightSidebar :itemId="itemId" v-model:visible="visibleRight" position="right" @close="visibleRight = false" />
</template>

<script lang="ts">

import {
  defineComponent,
  ref,
  h,
  onMounted,
  computed,
  watch,
  reactive,
  onUnmounted
} from "vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../components/FormComponents/BacktoMaster.vue";

import Itemcreation from "../../../../../modules/Inventory/pages/Masters/Items/ItemMaster/ItemCreation.vue";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import axios from "axios";
import service from "../../../../../modules/Inventory/Service/ItemMasService";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../components/FormComponents/Table.vue";
import { useI18n } from 'vue-i18n';
import EditConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../components/FormComponents/DeletedSuccessfully.vue";
import WithoutStockAffectService from "../../../../../modules/Inventory/Service/WithoutStockAffectService";
import ItemsRightSidebar from "../../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsRightSidebar.vue";
import Loader from "../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
export default defineComponent({
  components: {
    BacktoPage,
    Headerlayout,
    Itemcreation,
    axios,

    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    WithoutStockAffectService,
    ItemsRightSidebar,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
  },
  props: {
    propsParams: {
      type: Object,
    },
    QueryValue: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    debugger;

    const router = useRouter();
    const route = useRoute();

    const filter = "";
    const showmodalref = ref(false);
    let loading1 = ref(false);
    let title = "Item Master";
    let List: any = ref([]);
    const rowFocus = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const visibleRight = ref(false);
    const loading = ref(false);
    const itemId = ref(0);
    const rowsCount = ref(0);

    let ObjVal2 = reactive({
      arraylenght: 0,
    });


    let QueryStringValue = ref(route.query);

    watch(
      () => [props.QueryValue],
      ([newQueryValue]) => {
        debugger;
        if (newQueryValue) {
          QueryStringValue.value = newQueryValue;
        }
      },
      { immediate: true }
    );


    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    ////

    const headers = [
      {
        header: t('storetabdetails.pritemtable.Category'),
        field: "ItemCategory1",
        class: "smallwidth newcolumnfreezeleft1"
      },
      {
        header: t('storetabdetails.pritemtable.Code'),
        field: "ItemProductId",
        bodyclass: "boldclass text_overflow2",
        class: "smallwidth newcolumnfreezeleft2"
      },
      {
        header: t('storetabdetails.pritemtable.Name'),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft3",
      },
      {
        header: t('storetabdetails.pritemtable.Brand/Model/Size'),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "text_overflow2",
        class:"newcolumnfreezeleft4"
      },
      {
        header: t('storetabdetails.pritemtable.UOM'),
        field: "UOMName",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t('storetabdetails.pritemtable.AvlQty'),
        slot: 'StockInHand',
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t('storetabdetails.pritemtable.PickedQty'),
        field: "PickedQty",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pritemtable.InTransist'),
        field: "InTransist",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth"
      },

      // {
      //   header: t('storetabdetails.pritemtable.ReOrderLevel'),
      //   field: "ReOrderLevel",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: t('storetabdetails.pritemtable.PackSizename'),
        field: "PackSizename1",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pritemtable.PackSizeQty'),
        field: "PackSizeQty",
        bodyclass: "right_td",
        class: "smallwidth"
      },
      {
        header: t('storetabdetails.pritemtable.UnitRate'),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t('storetabdetails.pritemtable.ReqQty'),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t('storetabdetails.pritemtable.Rate'),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t('storetabdetails.prcreationtable.Description'),
        field: "Description",
        class: "smallwidth"
      },

    ];

    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Code: { value: null, matchMode: FilterMatchMode.IN, options: List },
      HSNName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ManufactureName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      UnitName: { value: null, matchMode: FilterMatchMode.IN, options: List },
      ItemCategoryName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemSubGroupName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      ItemGenericName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };
    onMounted(() => {
      debugger;
      window.addEventListener("resize", handleResize);
      document.addEventListener("keydown", onKeyUp);
      IsShow();
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    const dataEdit = ref();
    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true
      ) {
        Editmodel.value = true;
      } else if (event.altKey && event.key == "n") {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (event.key == "d" && rowFocus.value == true) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      }
    }

    function RowClick(event: any) {
      // visibleRight.value = true;
      // itemId.value = event.data.ItemId;
    }

    //Add New PopUp
    const IsAdd = () => {
      router.push({
        path: "/ItemMasterCreation",
      });
    };

    function IsConfirmEdit(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = true;
    }

    function IsConfirmDel(data) {
      debugger;
      dataEdit.value = data;
      Editmodel.value = false;
      Deletemodel.value = true;
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
    }

    function update() {
      debugger;
      emit("TableDetails", ObjVal2);
    }

    //Table List
    async function IsShow() {
      debugger;

      try {
        loading.value = true;
        const data_response =
          await WithoutStockAffectService.GetByStockWOTransId(
            QueryStringValue.value.PRId
          );
        List.value = data_response["result"].map((item) => {
          item.UnitRate = Number(item.UnitRate).toFixed(2);
          item.Rate = Number(item.Rate).toFixed(2);
          return item;
        });

        List.value.sort((a, b) => {
          return a.Itemname1.localeCompare(b.Itemname1);
        });

        ObjVal2.arraylenght = data_response["result"].length;

        if (data_response["result"].length > 0) {
          rowsCount.value = data_response["result"].length;
        }

        console.log(List.value);
        loading.value = false;
        update();
      } catch (error) {
        alert(error);
      }
    }

    //Edit Click function
    async function IsEdit(data) {
      debugger;
      router.push({
        path: "/ItemMasterCreation",
        query: { id: data.Id },
      });
    }

    //Row Delete
    async function IsDelete(data) {
      debugger;

      const DelID = data.Id;
      try {
        const data_response = await service.Delete(DelID);
        console.log(data_response);
        deletepop.value = true;
        Deletemodel.value = false;
        rowFocus.value = false;
        IsShow();
      } catch (error) {
        alert(error);
      }
    }

    return {
      title,
      headers,
      filter,
      showmodalref,
      showpopModal: showmodalref,
      loading1,
      List,
      IsDelete,
      filters,
      globalFilterFields,
      filteredColumns,
      IsShow,
      IsEdit,
      RowClick,
      dataEdit,
      Editmodel,
      IsAdd,
      onKeyUp,
      IsConfirmEdit,
      IsConfirmDel,
      Deletemodel,
      closetrigger,
      deletepop,
      visibleRight,
      loading,
      itemId,
      rowsCount,
      windowWidth
    };
  },
});
</script>
